const styles = {
	item: { fontFamily: 'Open Sans', color: '#646b6f', fontSize: '16px' },
	labelItem: { fontWeight: 'bold' }
};

export default styles;
